import { render, staticRenderFns } from "./lossThreshold.vue?vue&type=template&id=04cdc432&scoped=true&"
import script from "./lossThreshold.vue?vue&type=script&lang=js&"
export * from "./lossThreshold.vue?vue&type=script&lang=js&"
import style0 from "./lossThreshold.vue?vue&type=style&index=0&id=04cdc432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cdc432",
  null
  
)

export default component.exports